import { ACTION_TYPES } from "../../actions/telematics/TelematicsActions"

const initialState = {
    list: [],
    listOrders: [],
    evidences: [],
    installationOrderDetail: {},
    technicianList: [],
    phoneTypesList: [],
    subStage: [],
    subStagePerOrder: [],
    historyList: [],
    resultInvoice: {},
    resultComplement: {},
    listInvoicesComplement: {},
    listRejectedInvoices: [],
    listViaticDocuments: [],
    listInvoiceServiceDocuments: [],
    listExcelDocuments: [],
    technicianOrdersList: [],
    techniciansByOrder: []
}
export const TelematicsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                list: [],
                listOrders: [],
                evidence: [],
                orderDetail: {},
                installationOrderDetail: {},
                technicianList: [],
                phoneTypesList: [],
                subStage: [],
                subStagePerOrder: [],
                historyList: [],
                resultInvoice: {},
                resultComplement: {},
                listInvoicesComplement: {},
                listRejectedInvoices: [],
                listViaticDocuments: [],
                listInvoiceServiceDocuments: [],
                listExcelDocuments: [],
                technicianOrdersList: [],
                techniciansByOrder: []
            }
        case ACTION_TYPES.FETCH_DASHBOARD:
            return {
                ...state,
                list: [...action.payload]
            }
        case ACTION_TYPES.FETCH_OC_BY_STATUS:
            return {
                ...state,
                listOrders: [...action.payload]
            }
        case ACTION_TYPES.FETCH_INSTALLATION_ORDER_DETAIL:
            return {
                ...state,
                installationOrderDetail: action.payload
            }
        case ACTION_TYPES.FETCH_TECHNICIANS:
            return {
                ...state,
                technicianList: action.payload
            }
        case ACTION_TYPES.FILTER_TECHNICIANS:
            return {
                ...state,
                technicianList: action.payload
            }
        case ACTION_TYPES.FETCH_PHONE_TYPES:
            return {
                ...state,
                phoneTypesList: action.payload
            }
        case ACTION_TYPES.FETCH_VIATIC_DOCUMENTS:
            return {
                ...state,
                listViaticDocuments: [...action.payload]
            }
        case ACTION_TYPES.FETCH_EVIDENCE:
            return {
                ...state,
                evidences: [...action.payload]
            }
        case ACTION_TYPES.FETCH_REJECTED_INVOICE:
            return {
                ...state,
                listRejectedInvoices: [...action.payload]
            }
        case ACTION_TYPES.FETCH_INVOICE_SERVICE_DOCUMENTS:
            return {
                ...state,
                listInvoiceServiceDocuments: [...action.payload]
            }
        case ACTION_TYPES.FETCH_EXCEL_SERVICES:
            return {
                ...state,
                listExcelDocuments: [...action.payload]
            }
        case ACTION_TYPES.FETCH_TECHNICIANS_ORDERS:
            return {
                ...state,
                technicianOrdersList: [...action.payload]
            }
        case ACTION_TYPES.FETCH_TECHNICIANS_BY_ORDER:
            return {
                ...state,
                techniciansByOrder: [...action.payload]
            }
        default:
            return state
    }
}